import "./index.scss";

import React from "react";

const CustomButton = ({
  text,
  isSubmit,
  classNames,
  handleClick,
  isDisabled,
  animateButtonAndClass,
  type,
}) => {
  const number = type === "match" ? 1 : type === "proof" ? 2 : "";

  return isSubmit ? (
    <button
      className={`custom-button custom-button--modal ${
        classNames ? classNames : ""
      }`}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {text}
    </button>
  ) : type === "gallery" ? (
    <div
      className={
        animateButtonAndClass
          ? `${animateButtonAndClass} custom-button__wrap--anim`
          : ""
      }
    >
      <p className={`custom-button__text custom-button__text--gallery`}>
        Coming Q4 2021
      </p>
      <button className={`custom-button-updates`} onClick={handleClick} />
      {/* <button
        className={`custom-button ${classNames ? classNames : ""}`}
        onClick={handleClick}
      >
        Notify me about app updates
      </button> */}
    </div>
  ) : (
    <div
      className={
        animateButtonAndClass
          ? `${animateButtonAndClass} custom-button__wrap--anim`
          : ""
      }
    >
      <p className={`custom-button__text ${classNames ? classNames : ""}`}>
        Coming Q{number} 2021
      </p>
      <button className={`custom-button-notify`} onClick={handleClick} />
      {/* <button className={`custom-button`} onClick={handleClick}>
        notify me
      </button> */}
    </div>
  );
};

export default CustomButton;
